<template>
  <v-container>
    <v-btn
        href="https://m365.eu.vadesecure.com/safeproxy/v4?f=JlKwaXDbHQ1ZYerq3Ol-ie_BSx_VVXKEXN6Sn-5sVh2SrOwdVEKVwR7DEEHWCpma&i=MXQkl5HCv_ctFEEMLW47akH0CIMVafg5C6XOyG4PeLdwBwP-x7XBW0UVt22XREaV1-JrrvjoqfQExFFS8awp1Q&k=gFhP&r=oYWqIaaCjp5487ahvnmJBDGMhG3Tr1e_JdWXvfSAT1YzqK9nuu9jvF8QnJfXTE-2&s=d787d686a19bc3102118bcfeda7788d0a346673c0d7bd8a4297458ffc9cabdad&u=https%3A%2F%2Fdrive.google.com%2Fdrive%2Ffolders%2F1Aj40zLJntsVr9jbVLCRMmh40c-gQPDSM%3Fusp%3Dsharing"
        target="_blank"
        class="mt-3 white--text"
        width="100%"
        :color="getBleu"
    >
      Drive - documentation de pose
    </v-btn>
    <v-expansion-panels accordion focusable popout class="mt-3">
      <v-expansion-panel v-if="isPoseur || isGestionnaire || isAdmin">
        <v-expansion-panel-header>Tickets restaurants : Informations générales</v-expansion-panel-header>
        <v-expansion-panel-content>
          <br>
          <p>Le titre-restaurant est un titre spécial de paiement «des repas» remis par l’employeur au salarié.</p>
          <p>Les titres sont valables pour des aliments immédiatement consommables ou qui serviront à la préparation de votre repas. Notamment:</p>
          <ul>
            <li>D’un repas,</li>
            <li>De préparation alimentaires directement consommables,</li>
            <li>De fruits et légumes,</li>
            <li>De produits laitiers.</li>
          </ul>
          <br>
          <p>Le titre-restaurant étant considéré comme un avantage social il est généralement admis qu’il doit être accordé à tous les membres d’une même entreprise.</p>
          <p>Le titre restaurant est en partie financé par l'employeur, qui doit obligatoirement prendre à sa charge entre 50% et 60% de sa valeur.
            Il reste entre 40% et 50% de la valeur du ticket à la charge du salarié.
            (Dans le cas de l’entreprise Poupin, 60% du ticket restaurant est financé par l’employeur et 40% par l’employé,
            sauf dans le cas particulier d’un poseur qui lui dispose
            d’un panier repas légal de 9€33 payé par l’entreprise auquel vient s’ajouter sa participation).</p>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="isPoseur || isGestionnaire || isAdmin">
        <v-expansion-panel-header>Tickets restaurants : Conditions d'attribution et d'utilisation</v-expansion-panel-header>
        <v-expansion-panel-content>
          <br>
          <h4>Condition d’attribution</h4>

          <p>Il ne peut être attribué qu’un seul titre-restaurant par jour de travail et à condition que le repas soit compris dans l’horaire de travail journalier.
            Ainsi un salarié travaillant 5 jours de 8 heures à 17 heures pourra bénéficier de 5 titres-restaurant,
            au contraire un salarié n’effectuant pour une raison x que des demies journées ne pourra donc pas en bénéficier.</p>

          <p>Dans le cas particulier d’un grand déplacement une indemnité de repas est déjà attribuée, un titre restaurant ne sera donc pas octroyé en sus de cette indemnité.</p>

          <h4>Neutralisation des périodes d’absences</h4>

          <p>Les salariés absents (congés annuels, récupération du temps de travail, maladie, …) ne bénéficient pas des titres-restaurant pour les jours d’absences.</p>

          <h4>Condition d’utilisation</h4>
          <p>Les commerçants ne sont pas dans l'obligation d'accepter les titres-restaurant.
            Chaque enseigne de magasins fixe sa propre liste de produits payables par titre restaurant. Il peut donc y avoir des différences d'une enseigne à une autre.
            Vous pouvez utiliser vos titres-restaurant dans la limite de 19€ par jour. Si vous utilisez des titres papier, le commerçant n'a pas le droit de vous rendre la monnaie.</p>

          <h4>Bon à savoir:</h4>
          <p>C’est la commission nationale des titres-restaurant qui fixe les conditions d’attribution des  titres-restaurant.</p>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="isPoseur || isGestionnaire || isAdmin">
        <v-expansion-panel-header>Indemnité de trajet : Petits déplacements</v-expansion-panel-header>
        <v-expansion-panel-content>
          <br>
          <p>Il existe des indemnités de trajets journalier pour les «Petits déplacements».</p>
          <p>Il s’agit d’un forfait légal qui suit la grille régionale (de 0 à 80km à vol d’oiseau)
            auquel l’entreprise Poupin à ajouté une extension pour les déplacements à la journée dans la fourchette des 80km à 160km
            (bien que pour des raison de sécurité il soit recommandé de passer sur des grands déplacements).</p>
          <a :href="downloadFile.dir" download="TableauZones.png">
            <v-btn color="blue" outlined><v-icon>mdi-download</v-icon> Tableau des zones 2020</v-btn>
          </a>

          <br>
          <br>

          <p>Pour les déplacements de plus de 80km et qui nécessitent d’effectuer une ou des nuitées sur place on parle de «Grands déplacements»,
            ces trajets peuvent être indemnisés de deux manières différentes.</p>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="isPoseur || isGestionnaire || isAdmin">
        <v-expansion-panel-header>Indemnité de trajet : Grands déplacements (Frais réels)</v-expansion-panel-header>
        <v-expansion-panel-content>
          <br>
          <ul>
            <li>Dans le cas des frais réel l’entreprise propose de régler directement les frais liés au déplacement.</li>
            <li>Un prime de déplacement de 35€ est octroyé par nuitée.</li>
            <li>Le logement est organisé avec l’entreprise (avec pièces individuelles pour le couchage).</li>
            <li>Les paiements des repas doivent être réglés par CB dans la limite de 16€ MAX le midi et de 24€ MAX le soir.</li>
          </ul>
          <br>
          <h4>À noter:</h4>
          <p>L’indemnité de grand déplacement correspond aux dépenses journalières normales qu’engage le déplacé en plus des dépenses habituelles qu’il engagerait s’il n’était pas déplacé.</p>

        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="isPoseur || isGestionnaire || isAdmin">
        <v-expansion-panel-header>Indemnité de trajet : Grands déplacements (Allocation forfaitaire)</v-expansion-panel-header>
        <v-expansion-panel-content>
          <br>
          <ul>
            <li>Dans le cas de l’allocation forfaitaire l’entreprise propose de verser par virement un forfait avec montant fixe lié aux coûts du déplacement.</li>
            <li>Un prime de déplacement de 28€ est octroyé par nuitée (tous départements confondus).</li>
            <li>Le logement est organisé  avec l’entreprise.</li>
            <li>Le salarié bénéficie d’une indemnité repas de 19€ le midi ET le soir.</li>
            <li>72€ d’indemnités de couchage (logement et petit déjeuners) sont versés par nuitée pour la région parisienne.</li>
            <li>55€ d’indemnités de couchage (logement et petit déjeuners) sont versés par nuitée pour les autres régions.</li>
          </ul>
          <br>
          <h4>À noter:</h4>
          <p>L’indemnité de grand déplacement correspond aux dépenses journalières normales qu’engage le déplacé en plus des dépenses habituelles qu’il engagerait s’il n’était pas déplacé.</p>

        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>Documentation de pose</v-expansion-panel-header>
        <v-expansion-panel-content>
          <br>
          <iframe width="100%" height="auto" src="https://www.youtube.com/embed/rfiqfPcc0VU" title="YouTube video player" frameborder="0" allow="clipboard-write; encrypted-media; picture-in-picture" allowfullscreen></iframe>
          <br>
          <iframe width="100%" height="auto" src="https://www.youtube.com/embed/1kWeT3SQFfY" title="YouTube video player" frameborder="0" allow="clipboard-write; encrypted-media; picture-in-picture" allowfullscreen></iframe>
          <div class="mt-2 mb-1">
            <v-btn width="100%" class="my-2 mx-0" @click="current_pdf = pdf_1; currentPage = 1">Calepin chantier</v-btn>
            <v-btn width="100%" class="my-2" @click="current_pdf = pdf_2; currentPage = 1">Normes garde corps</v-btn>
            <v-btn width="100%" class="my-2" @click="current_pdf = pdf_3; currentPage = 1">Guide pose neuf</v-btn>
          </div>
          <v-pagination
              v-model="currentPage"
              :length="pageCount"

          >
          </v-pagination>
          <pdf
              class="mt-3"
              :src="current_pdf"
              :page="currentPage"
              @num-pages="pageCount = $event"
              @page-loaded="currentPage = $event"
          ></pdf>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import pdf from 'vue-pdf';

export default {
  name: "x-info",
  components: {
    pdf
  },
  data() {
    return {
      downloadFile: { dir: require('../../assets/infos/tableau_petits_deplacement.png')},
      current_pdf: {},
      pdf_1: require('../../assets/doc/calepin.pdf'),
      pdf_2: require('../../assets/doc/guidegardecorps.pdf'),
      pdf_3: require('../../assets/doc/guiderenovation.pdf'),
      currentPage: 1,
      pageCount: 0,
    }
  },
  created() {
    this.current_pdf = this.pdf_1;
  },
  methods: {
    download() {
      let blob = new Blob([]);
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Tableau.png';
      link.click();
    },
    precedente() {
      if(this.currentPage > 1) {
        this.currentPage -= 1
      }
    },
    suivante() {
      if(this.currentPage < this.pageCount) {
        this.currentPage += 1
      }
    }
  },
  computed: {
    ...mapGetters('auth', {
      isPoseur: 'isPoseur',
      isAdmin: 'isAdmin',
      isGestionnaire: 'isGestionnaire'
    }),
    ...mapGetters(['getBleu'])
  },
}
</script>

<style scoped>

</style>